import React from "react";
import logo from "../assets/images/olympusLogoAndName.png";

export default function NavBarLogo() {
  return (
    <a className="navbar-brand" href="/">
      <img src={logo} alt="Logo" height="40px" />
    </a>
  );
}
